import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

const featuredArticles = allArticles.filter((a) => a.slug !== 'vigorbuy-spreadsheet-guide');

export default function ArticleCTA() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            Expert Guides
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Vigorbuy Spreadsheet Resources
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Dive deeper into product discovery with our expert-written guides, comparisons, and shopping tips.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium whitespace-nowrap">
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <span className="text-accent-600 text-xs font-medium mb-2">{article.badge.split('•')[0].trim()}</span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.metaDescription}
                </p>
                <span className="inline-flex items-center gap-1.5 text-primary-500 text-sm font-medium whitespace-nowrap">
                  Read Article
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/vigorbuy-spreadsheet-shopping-guide"
            className="inline-flex items-center justify-center gap-2.5 px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/20 whitespace-nowrap cursor-pointer"
          >
            <span>View Shopping Guide</span>
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}